import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Layout from "components/Layout";
// Add your imports here
import HomepageHeroExperienceHub from "pages/homepage-hero-experience-hub";
import ExperienceCareerJourneyTimeline from "pages/experience-career-journey-timeline";
import ContactCollaborationGateway from "pages/contact-collaboration-gateway";
import AboutProfessionalStoryCenter from "pages/about-professional-story-center";
import ProjectsInnovationLaboratory from "pages/projects-innovation-laboratory";
import SkillsTechnicalMasteryShowcase from "pages/skills-technical-mastery-showcase";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your routes here */}
        <Route path="/" element={<Layout><HomepageHeroExperienceHub /></Layout>} />
        <Route path="/homepage-hero-experience-hub" element={<Layout><HomepageHeroExperienceHub /></Layout>} />
        <Route path="/experience-career-journey-timeline" element={<Layout><ExperienceCareerJourneyTimeline /></Layout>} />
        <Route path="/contact-collaboration-gateway" element={<Layout><ContactCollaborationGateway /></Layout>} />
        <Route path="/about-professional-story-center" element={<Layout><AboutProfessionalStoryCenter /></Layout>} />
        <Route path="/projects-innovation-laboratory" element={<Layout><ProjectsInnovationLaboratory /></Layout>} />
        <Route path="/skills-technical-mastery-showcase" element={<Layout><SkillsTechnicalMasteryShowcase /></Layout>} />
        <Route path="*" element={<Layout><NotFound /></Layout>} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;